import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb2b0bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "game-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "game-page__scrim" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/paladium/logo.webp",
    alt: "Paladium",
    draggable: "false"
  })
], -1))
const _hoisted_4 = { class: "chrome" }
const _hoisted_5 = {
  class: "head",
  style: {"--s":"26px"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "user__name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "chev",
  viewBox: "0 0 10 6",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1l4 4 4-4",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_9 = { class: "pop-head" }
const _hoisted_10 = {
  class: "head",
  style: {"--s":"34px"}
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "pop-head__id" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Compte Microsoft", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pop-sep" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pop-lab" }, "Changer de compte", -1))
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = {
  class: "head",
  style: {"--s":"22px"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "pop-name" }
const _hoisted_20 = {
  key: 0,
  class: "row-spin"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "6",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-dasharray": "27 11"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pop-sep" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "i",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5 6a5 5 0 0 1 10 0H1Zm10.5-6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM12 14a6 6 0 0 0-1.6-4.1A4 4 0 0 1 15 13.5v.5h-3Z" })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "i",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.6 1h2.8l.4 1.9 1.1.6 1.8-.7 1.4 2.4-1.4 1.3v1.2l1.4 1.3-1.4 2.4-1.8-.7-1.1.6-.4 1.9H6.6l-.4-1.9-1.1-.6-1.8.7L1.9 9.3l1.4-1.3V6.8L1.9 5.5l1.4-2.4 1.8.7 1.1-.6L6.6 1ZM8 10.3a2.3 2.3 0 1 0 0-4.6 2.3 2.3 0 0 0 0 4.6Z" })
], -1))
const _hoisted_26 = { id: "game-page__content" }
const _hoisted_27 = { class: "headline" }
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { class: "description" }
const _hoisted_30 = ["aria-disabled"]
const _hoisted_31 = ["data-phase", "aria-live"]
const _hoisted_32 = {
  class: "launch__steps",
  "aria-hidden": "true"
}
const _hoisted_33 = { class: "launch__name" }
const _hoisted_34 = { class: "launch__bar" }
const _hoisted_35 = { class: "launch__track" }
const _hoisted_36 = { class: "launch__readout" }
const _hoisted_37 = {
  key: 0,
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 3l6 6M9 3l-6 6",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { class: "launch__status" }
const _hoisted_42 = { class: "launch__icon" }
const _hoisted_43 = {
  key: 0,
  class: "launch__badge",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "#ff453a"
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5.3 5.3l5.4 5.4M10.7 5.3l-5.4 5.4",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "1.8",
  "stroke-linecap": "round"
}, null, -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "6",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-dasharray": "27 11"
}, null, -1))
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 2,
  class: "launch__badge",
  viewBox: "0 0 16 16",
  "aria-hidden": "true"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "8",
  cy: "8",
  r: "8",
  fill: "#3fb950"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4.6 8.3l2.2 2.2 4.6-4.8",
  fill: "none",
  stroke: "#fff",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = ["title"]
const _hoisted_54 = {
  key: 0,
  class: "launch__aside"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 1.5v8M2.8 6.6 6 9.8l3.2-3.2",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_56 = {
  key: 0,
  class: "launch__actions"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 6a4 4 0 1 1-1.2-2.9M10 1.8v2.4H7.6",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_58 = {
  key: 0,
  viewBox: "0 0 10 10",
  "aria-hidden": "true"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 1h6v6M9 1 3.5 6.5",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = ["disabled", "title"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "chev",
  viewBox: "0 0 10 6",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 1l4 4 4-4",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pop-lab" }, "Distribution", -1))
const _hoisted_65 = { class: "pop-list" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["src", "alt"]
const _hoisted_68 = { class: "pop-name" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "chk",
  viewBox: "0 0 12 12",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.5 6.4 4.9 8.8 9.6 3.6",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayIcon = _resolveComponent("PlayIcon")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.data)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            id: "game-page__background",
            style: _normalizeStyle(`background-image: url('${_ctx.data.backgroundImage}');`)
          }, null, 4),
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["user", { 'is-busy': _ctx.switchingUuid }]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args)), ["stop"]))
            }, [
              _createElementVNode("span", _hoisted_5, [
                (_ctx.currentSkin)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.currentSkin,
                      alt: "",
                      draggable: "false",
                      onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.headError && _ctx.headError(...args)))
                    }, null, 40, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.displayName), 1),
              _hoisted_8
            ], 2),
            _createVNode(_Transition, { name: "pala-menu" }, {
              default: _withCtx(() => [
                (_ctx.userMenuOpen)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "pop pop-user",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          (_ctx.currentSkin)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.currentSkin,
                                alt: "",
                                draggable: "false",
                                onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.headError && _ctx.headError(...args)))
                              }, null, 40, _hoisted_11))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.displayName), 1),
                          _hoisted_13
                        ])
                      ]),
                      (_ctx.otherAccounts.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_14,
                            _hoisted_15,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherAccounts, (account) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: account.uuid,
                                type: "button",
                                class: "pop-item",
                                disabled: !!_ctx.switchingUuid,
                                onClick: ($event: any) => (_ctx.switchAccount(account.uuid))
                              }, [
                                _createElementVNode("span", _hoisted_17, [
                                  _createElementVNode("img", {
                                    src: _ctx.headUrl(account.uuid),
                                    alt: "",
                                    draggable: "false",
                                    onError: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.headError && _ctx.headError(...args)))
                                  }, null, 40, _hoisted_18)
                                ]),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(account.name), 1),
                                (_ctx.switchingUuid === account.uuid)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                      (_openBlock(), _createElementBlock("svg", {
                                        viewBox: "0 0 16 16",
                                        "aria-hidden": "true",
                                        style: _normalizeStyle({ transform: `rotate(${_ctx.switchSpin}deg)` })
                                      }, _hoisted_22, 4))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_16))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true),
                      _hoisted_23,
                      _createElementVNode("button", {
                        type: "button",
                        class: "pop-item",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openAccounts && _ctx.openAccounts(...args)))
                      }, [
                        _hoisted_24,
                        _createTextVNode(" Gérer les comptes ")
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "pop-item",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openSettings && _ctx.openSettings(...args)))
                      }, [
                        _hoisted_25,
                        _createTextVNode(" Paramètres ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("h2", _hoisted_27, _toDisplayString(_ctx.data.headline), 1),
            _createElementVNode("h1", _hoisted_28, _toDisplayString(_ctx.data.name), 1),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.data.description), 1),
            _createElementVNode("div", {
              class: "actions",
              "aria-disabled": !_ctx.gameState.launchable
            }, [
              (_ctx.launchActive)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "launch",
                    "data-phase": _ctx.dispPhase,
                    role: "status",
                    "aria-live": _ctx.dispPhase === 'error' ? 'assertive' : 'polite'
                  }, [
                    _createElementVNode("ol", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: _normalizeClass(["launch__step", { 'is-done': step.done, 'is-active': step.active, 'is-determinate': step.active && !step.indeterminate, 'is-indeterminate': step.indeterminate, 'is-error': step.error }])
                        }, [
                          _createElementVNode("span", _hoisted_33, _toDisplayString(step.name), 1),
                          _createElementVNode("span", _hoisted_34, [
                            _createElementVNode("span", _hoisted_35, [
                              _createElementVNode("span", {
                                class: "launch__fill",
                                style: _normalizeStyle(_ctx.fillStyle(step))
                              }, null, 4)
                            ]),
                            _createElementVNode("span", _hoisted_36, [
                              (step.error)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_37, _hoisted_39))
                                : (step.readout === 'pct')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.stepPct) + "%", 1))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("span", _hoisted_42, [
                        (_ctx.dispPhase === 'error')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_43, _hoisted_46))
                          : (_ctx.dispPhase !== 'ready')
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 1,
                                class: "launch__spin",
                                viewBox: "0 0 16 16",
                                "aria-hidden": "true",
                                style: _normalizeStyle({ transform: `rotate(${_ctx.motion.spin}deg)` })
                              }, _hoisted_48, 4))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_52))
                      ]),
                      _createElementVNode("span", {
                        class: "launch__msg",
                        title: _ctx.dispPhase === 'error' ? _ctx.detailText : ''
                      }, [
                        _createVNode(_Transition, {
                          name: "launch-msg",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock("span", { key: _ctx.detailText }, _toDisplayString(_ctx.detailText), 1))
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_53),
                      (_ctx.dispPhase === 'download' && _ctx.downloadSpeed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                            _hoisted_55,
                            _createTextVNode(" " + _toDisplayString(_ctx.downloadSpeed), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.dispPhase === 'error')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          (_ctx.errorRetryable)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "launch__btn launch__btn--primary",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.actionBtn && _ctx.actionBtn(...args)))
                              }, [
                                _hoisted_57,
                                _createTextVNode(" Réessayer ")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: "launch__btn launch__btn--ghost",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.dismissLaunch && _ctx.dismissLaunch(...args)))
                          }, "Fermer"),
                          (_ctx.errorLink)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "launch__link",
                                href: "#",
                                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.errorLink.action && _ctx.errorLink.action(...args)), ["prevent"]))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.errorLink.label) + " ", 1),
                                (_ctx.errorLink.external)
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_58, _hoisted_60))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_31))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["split", { single: !_ctx.hasMultipleDist }])
                  }, [
                    _createElementVNode("button", {
                      disabled: !_ctx.gameState.launchable,
                      title: _ctx.gameState.launchable ? '' : 'Ce service n\'est pas autorisé sur Linux',
                      type: "button",
                      class: "play",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.actionBtn && _ctx.actionBtn(...args)))
                    }, [
                      (_ctx.gameState.installed)
                        ? (_openBlock(), _createBlock(_component_PlayIcon, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_DownloadIcon, { key: 1 })),
                      _createTextVNode(" " + _toDisplayString(_ctx.gameState.installed ? 'Jouer' : 'Installer'), 1)
                    ], 8, _hoisted_61),
                    (_ctx.hasMultipleDist)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "more",
                            "aria-label": "Choisir la distribution",
                            onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDistMenu && _ctx.toggleDistMenu(...args)), ["stop"]))
                          }, _hoisted_63),
                          _createVNode(_Transition, { name: "pala-menu" }, {
                            default: _withCtx(() => [
                              (_ctx.distMenuOpen)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "pop pop-dist",
                                    onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _hoisted_64,
                                    _createElementVNode("div", _hoisted_65, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameState.allVersions, (option) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: option.id,
                                          type: "button",
                                          class: _normalizeClass(["pop-item", { on: option.id === _ctx.gameState.selectedVersion }]),
                                          onClick: ($event: any) => (_ctx.chooseDistribution(option))
                                        }, [
                                          (option.icon && option.icon.length > 0)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "pop-ico",
                                                src: option.icon,
                                                alt: option.value
                                              }, null, 8, _hoisted_67))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("span", _hoisted_68, _toDisplayString(option.value), 1),
                                          _hoisted_69
                                        ], 10, _hoisted_66))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2))
            ], 8, _hoisted_30)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}